import { setTerm } from './helpers';

export const setPrepay = setTerm('prepay');
